import { render, staticRenderFns } from "./email_form.vue.js?vue&type=template&id=70d8cc8d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email_form.vue?vue&type=template&id=70d8cc8d"
import script from "./email_form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email_form.vue?vue&type=script&lang=js"
export * from "./email_form.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d8cc8d')) {
      api.createRecord('70d8cc8d', component.options)
    } else {
      api.reload('70d8cc8d', component.options)
    }
    module.hot.accept("./email_form.vue.js?vue&type=template&id=70d8cc8d!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email_form.vue?vue&type=template&id=70d8cc8d", function () {
      api.rerender('70d8cc8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "sessions/new/components/email_form.vue"
export default component.exports